import { Data, IBarValue } from "components/BarsChartFailureCodes/BarsValueInterfaces";

export const ReportDowntimeBarChartPercentOnFirstBarLayer = ({ bars, xScale }: IBarValue) => {
    const xValues: number[] = [];
    const yValues: number[] = [];
    return bars.map(({ data: { data, indexValue }, y, height }: Data, i: number) => {
        if (xValues.includes(xScale(Number(data.totalDowntimeByMill))) && yValues.includes(y)) {
            return <g key={`${indexValue}-${i}`} />;
        }
        xValues.push(xScale(Number(data.totalDowntimeByMill)));
        yValues.push(y);
        return (
            <g transform={`translate(${xScale(Number(data.totalDowntimeByMill))})`} key={`${indexValue}-${i}`}>
                <text
                    className="bar-total-label"
                    fontFamily="Source Sans 3"
                    fontSize={12}
                    fontWeight={600}
                    x={height - height / 1.1}
                    y={y + height / 2}
                    textAnchor="start"
                    alignmentBaseline="central"
                    style={{
                        fill: "rgb(51, 51, 51)",
                    }}
                >
                    {Number(data.totalDowntimeByMill).toFixed(1)}%
                </text>
            </g>
        );
    });
};
